import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  trigger: {
    display: 'inline-flex',
    width: theme.new.spacing.xl,
    height: theme.new.spacing.xl,
  },
  button: {
    '&:active:not(.Mui-disabled)': {
      backgroundColor: theme.new.color.brand[100],
      color: theme.new.color.brand[600],
    },
    '&.Mui-disabled': {
      backgroundColor: theme.new.color.common.white,
      color: theme.new.color.grey[400],
      opacity: 1,
    },
  },
  tooltip: {
    ...theme.typography.caption_regular,
    lineHeight: theme.typography.overline_semibold.lineHeight,
    maxWidth: 'none',
    padding: `${theme.new.spacing.xsmall} ${theme.new.spacing.small}`,
    borderRadius: theme.new.shape.borderRadius.small,
    backgroundColor: theme.new.color.textPrimary,
    color: theme.new.color.common.white,
  },
}));

export default useStyles;
